import request from "@/utils/request";

export function loginByUsername(username, password) {
  const data = {
    username,
    password,
  };
  return request({
    url: "/api/auth/login",
    method: "post",
    data,
  });
}

export function register(data) {
  return request({
    url: "/api/auth/register",
    method: "post",
    data,
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js